/**
 * @namespace {BX.UI}
 */
export default class AlertSize
{
	static MD = 'ui-alert-md';
	static XS = 'ui-alert-xs';
}